import { render, staticRenderFns } from "./dialogConfirmRedeem.vue?vue&type=template&id=145308ca&scoped=true"
import script from "./dialogConfirmRedeem.vue?vue&type=script&lang=js"
export * from "./dialogConfirmRedeem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145308ca",
  null
  
)

export default component.exports